import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'message-divider',
    templateUrl: './message-divider.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageDividerComponent {
    public readonly text = input<string>();
}
